import { render, staticRenderFns } from "./PrintDispatchInfo.vue?vue&type=template&id=5151646f"
import script from "./PrintDispatchInfo.vue?vue&type=script&lang=js"
export * from "./PrintDispatchInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports